/**
 * Helpers de roles SST.
 * Los IDs deben coincidir con sst-back/database/seeders/RolSeeder.php
 * y con sst-back/config/roles_sst.php.
 */

export const ROLES = {
  SUPER_ROOT: 1,
  DISENO_SST: 2,
  SOPORTISTA: 3,
  COMPANIA: 4,
  EMPLEADO: 5,
  CLIENTE_ADMIN: 6,
  TALENTO_HUMANO: 7,
  RESPONSABLE_OPERATIVO: 8,
}

/**
 * Roles con acceso a Reportes e Indicadores (Permiso P7).
 * Mantener en sincronia con roles_with_reports en sst-back/config/roles_sst.php.
 */
export const ROLES_WITH_REPORTS = [
  ROLES.SUPER_ROOT,
  ROLES.DISENO_SST,
  ROLES.COMPANIA,
  ROLES.CLIENTE_ADMIN,
]

/**
 * Items SG-SST permitidos para Talento Humano (por sequence).
 * Mantener en sincronia con talento_humano_items_allowed en sst-back/config/roles_sst.php.
 */
export const TALENTO_HUMANO_ITEMS_ALLOWED = ['3.3.4', '3.3.6']

/**
 * Devuelve el rol del usuario actualmente logueado (segun localStorage.info.role)
 * o null si no hay sesion.
 */
export function getCurrentRole() {
  try {
    const info = JSON.parse(localStorage.getItem('info'))
    if (!info || info.role === undefined || info.role === null) return null
    return Number(info.role)
  } catch (e) {
    return null
  }
}

export function canAccessReports(role = getCurrentRole()) {
  return ROLES_WITH_REPORTS.includes(Number(role))
}

export function isTalentoHumano(role = getCurrentRole()) {
  return Number(role) === ROLES.TALENTO_HUMANO
}

export function canAccessItemSequence(sequence, role = getCurrentRole()) {
  if (Number(role) === ROLES.TALENTO_HUMANO) {
    return TALENTO_HUMANO_ITEMS_ALLOWED.includes(sequence)
  }
  return true
}
